<template>
  <div>
    <Boyo-Dialog :dialogInfo="dialogInfoData" @dialogEvent="dialogEventData">
      <div style="display: flex; flex-direction: row; align-items: flex-start;">
        <!-- 审批步骤 -->
        <div style="width: 240px; min-width: 240px; margin-right: 24px;">
          <el-steps direction="vertical" :active="activeValue">
            <el-step v-for="(item, index) in activeList" :key="index" :title="item.processNodeName" :status="item.stepStatus || 'process'">
              <template #description>
                <div v-if="item.processNodeName === '制单人'">
                  {{ item.approvalTime }}
                </div>
                <div v-else>
                  <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                  <div>流程节点：{{ item.processNodeName || '' }}</div>
                  <div>经办人：{{ item.maker || '' }}</div>
                  <div v-if="item.stepStatus !== 'process'">备注：{{ item.remark || (item.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                  <div>时间：{{ item.makerTime || '' }}</div>
                </div>
              </template>
            </el-step>
          </el-steps>
        </div>
        <!-- 详情 -->
        <div style="flex: 1; overflow-x: auto;">
          <Boyo-Formtwo
            :formInfo="formInfo2"
            :refObj.sync="formInfo2.ref"
            :listTypeInfo="listTypeInfo"
          />
          <el-table
            :data="tableData"
            border
            max-height="360"
            style="width: 99%;margin-top:12px;"
            :header-cell-style="{background:'rgb(189,215,252)',color:'#3C3C3C',padding:'4px 0'}"
            :cell-style="{padding:'2px'}"
          >
            <el-table-column prop="materialNo" label="物料编号" width="120"></el-table-column>
            <el-table-column prop="materialName" label="物料名称" min-width="160"></el-table-column>
            <el-table-column prop="materialSpec" label="规格" width="120"></el-table-column>
            <el-table-column prop="unitName" label="单位" width="80"></el-table-column>
            <el-table-column prop="quantity" label="数量" width="90"></el-table-column>
            <el-table-column prop="price" label="含税单价" width="100"></el-table-column>
            <el-table-column prop="taxRate" label="税率(%)" width="90"></el-table-column>
            <el-table-column prop="amount" label="含税金额" width="110"></el-table-column>
          </el-table>

          <!-- 审核表单 -->
          <div v-if="showAuditDataFields" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
            <div class="quick-phrase-area">
              <div class="quick-phrase-label">常用快捷短语:</div>
              <div class="quick-phrase-buttons">
                <el-button
                  v-for="(phrase, index) in quickPhrases"
                  :key="index"
                  size="mini"
                  @click="insertQuickPhrase(phrase)"
                  class="phrase-btn"
                >
                  {{ phrase }}
                </el-button>
              </div>
            </div>
            <Boyo-Formtwo
              :formInfo="formInfoAuditData"
              :refObj.sync="formInfoAuditData.ref"
              :listTypeInfo="listTypeInfo"
            />
          </div>
        </div>
      </div>
    </Boyo-Dialog>
  </div>
</template>

<script>
import BoyoDialog from '@/components/BoyoDialog'
import BoyoFormtwo from '@/components/BoyoFormtwo'

export default {
  name: 'QuoteApprovalDialog',
  components: {
    BoyoDialog,
    BoyoFormtwo
  },
  data() {
    return {
      activeValue: null,
      activeList: [],
      billId: '',
      dataId: '',
      maker: '无',
      makerTime: '',
      tableData: [],
      detailDate: {},
      auditParm: {},
      showAuditDataFields: false,
      quickPhrases: ['同意', '不同意', '请补充附件', '报价单'],
      listTypeInfo: {
        statusFlag2: [
          { value: 1, label: '同意' },
          { value: 2, label: '不同意' }
        ],
        processId: []
      },
      dialogInfoData: {
        visible: false,
        width: '1200px',
        title: {
          add: '报价单对应数据'
        },
        type: 'add',
        btList: [
          { label: '审核', type: 'success', icon: '', event: 'save', loading: false, show: false },
          { label: '关闭', type: '', icon: '', event: 'close', loading: false }
        ]
      },
      formInfo2: {
        ref: null,
        labelWidth: '110px',
        inline: true,
        data: {
          orderNo: '',
          factoryAreaName: '',
          partnerName: '',
          orderDate: '',
          maker: '',
          remark: ''
        },
        list: [
          { type: 'text', label: '订单号：', value: 'orderNo', style: 'width:95%', className: 'form_item_two', disabled: true },
          // { type: 'text', label: '所属单位：', value: 'factoryAreaName', style: 'width:95%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '客户/供应商：', value: 'partnerName', style: 'width:95%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '订单日期：', value: 'orderDate', style: 'width:95%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '制单人：', value: 'maker', style: 'width:95%', className: 'form_item_two', disabled: true },
          { type: 'textarea', label: '备注：', value: 'remark', style: 'width:95%', className: 'form_item_two', disabled: true }
        ],
        rules: {}
      },
      formInfoAuditData: {
        ref: null,
        labelWidth: '100px',
        data: {
          id: '',
          processId: '',
          remark: '',
          status: ''
        },
        list: [
          { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%', disabled: true },
          { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one', list: 'statusFlag2', unclearable: true },
          { type: 'text', label: '备注：', value: 'remark', style: 'width:80%' }
        ],
        rules: {
          status: [{ required: true, trigger: 'change', message: '请选择' }]
        }
      }
    }
  },
  methods: {
    dialogShow(data, val, parm, id, maker, makerTime) {
      this.billId = data
      this.dataId = id
      this.maker = maker || '无'
      this.makerTime = makerTime || ''

      if (parm && parm.id) {
        this.auditParm = parm
        this.dialogInfoData.btList[0].show = true
        this.showAuditDataFields = true

        this.$nextTick(() => {
          for (const key in this.formInfoAuditData.data) {
            this.formInfoAuditData.data[key] = ''
          }
          this.loadProcessEnum().then(() => {
            let processFound = false
            for (const item of this.listTypeInfo.processId) {
              if (parm.processId === item.enumValue) {
                this.formInfoAuditData.data.processId = item.value
                processFound = true
                break
              }
            }
            if (!processFound) {
              console.warn('未找到匹配的流程ID:', parm.processId, '可用流程:', this.listTypeInfo.processId)
              this.formInfoAuditData.data.processId = parm.processId
            }
            this.formInfoAuditData.data.status = 1
          })
        })
      } else {
        this.dialogInfoData.btList[0].show = false
        this.showAuditDataFields = false
      }

      this.getInfo(val)
    },
    loadProcessEnum() {
      return new Promise(resolve => {
        if (this.listTypeInfo.processId && this.listTypeInfo.processId.length > 0) {
          resolve()
          return
        }
        this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
          if (res.code === 0) {
            this.listTypeInfo.processId = res.data.list.map(item => ({value: item.processId, enumValue: item.processCode, label: item.name}))
          }
          resolve()
        }).catch(() => resolve())
      })
    },
    getInfo(val) {
      // 审批步骤
      this.$api.system.getActProcessEntryPage({ idProcessInstance: this.dataId, pageNum: 1, pageSize: 999 }).then(res => {
        if (res.code === 0) {
          this.activeList = []
          this.activeValue = 0
          res.data.list.forEach((item, idx) => {
            if (item.status && idx < res.data.list.length) {
              this.activeValue = Number(idx + 1)
            }
            let stepStatus = 'process'
            if (item.status === 1) stepStatus = 'success'
            else if (item.status === 2) stepStatus = 'error'
            this.activeList.push({
              processNodeName: item.processNodeName || '',
              maker: item.status ? item.actualApprover : (item.approver ? item.approver : item.roleName),
              remark: item.remark || '',
              makerTime: item.approvalTime || '',
              stepStatus
            })
          })
          const approvalTime = this.maker + (this.makerTime ? (' ' + this.makerTime) : '')
          this.activeList.unshift({ processNodeName: '制单人', approvalTime })
          this.activeValue = (this.activeValue || 0) + 1
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      })

      // 报价单主表
      this.$api.Sale.getSalQuote({ id: this.billId }).then(res => {
        if (res.code === 0 && res.data) {
          const q = res.data
          this.detailDate = q
          this.formInfo2.data.orderNo = q.orderNo || ''
          this.formInfo2.data.factoryAreaName = q.factoryAreaName || ''
          this.formInfo2.data.partnerName = q.partnerName || ''
          this.formInfo2.data.orderDate = q.orderDate ? q.orderDate.substring(0, 10) : ''
          this.formInfo2.data.maker = q.createBy || ''
          this.formInfo2.data.remark = q.remark || ''
        } else {
          this.$message({ message: res.msg || '报价单不存在', type: 'warning' })
        }
      })

      // 报价单行
      this.$api.Sale.getSalQuoteEntryPage({ orderId: this.billId, pageNum: 1, pageSize: 999 }).then(res => {
        if (res.code === 0 && res.data) {
          const list = res.data.list || []
          this.tableData = list.map(item => {
            const qty = item.quantity != null ? item.quantity : (item.salQuantity != null ? item.salQuantity : item.qty)
            const price = item.price != null ? item.price : (item.salPrice != null ? item.salPrice : item.taxPrice)
            const taxRateRaw = item.taxRate != null ? item.taxRate : item.salTaxRate
            const taxRate = taxRateRaw != null && taxRateRaw < 1 ? (Number(taxRateRaw) * 100).toFixed(2) : taxRateRaw
            const amount = item.salMoney != null ? item.salMoney : (price != null && qty != null ? Number(price) * Number(qty) : item.salMoney)
            return {
              materialNo: item.materialNo || item.materialCode,
              materialName: item.materialName,
              materialSpec: item.materialSpec,
              unitName: item.unitName || item.salUnit,
              quantity: qty,
              price,
              taxRate,
              amount
            }
          })
        } else {
          this.tableData = []
        }
        if (!val) {
          this.dialogInfoData.visible = true
        }
      })
    },
    dialogEventData(event) {
      const dialogInfoData = this.dialogInfoData
      switch (event) {
        case 'save':
          this.formInfoAuditData.ref.validate(valid => {
            if (!valid) return
            const parma = {
              id: this.auditParm.id,
              processId: this.formInfoAuditData.data.processId,
              status: this.formInfoAuditData.data.status,
              remark: this.formInfoAuditData.data.remark
            }
            dialogInfoData.btList[0].loading = true
            this.$api.system.approval(parma).then(res => {
              dialogInfoData.btList[0].loading = false
              if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                dialogInfoData.visible = false
                this.$emit('approvalInfo')
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            }).catch(() => {
              dialogInfoData.btList[0].loading = false
            })
          })
          break
        case 'close':
          dialogInfoData.visible = false
          break
      }
    },
    insertQuickPhrase(phrase) {
      const currentRemark = this.formInfoAuditData.data.remark || ''
      this.formInfoAuditData.data.remark = currentRemark ? (currentRemark + ' ' + phrase) : phrase
    }
  }
}
</script>

<style scoped>
.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}
.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}
.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.phrase-btn {
  margin: 0;
  white-space: nowrap;
}
</style>




// WEBPACK FOOTER //
// src/components/Custom/QuoteApprovalDialog.vue